@if (isRequired) {
  <mat-form-field appearance="fill" class="flex-100 input-container">
    <mat-label>{{ 'labels.inputs.' + inputLabel | translate }}</mat-label>
    <div class="input-group">
      <span>{{ currency.code }}</span>
      <input
        LOSxFormatAmount="{{ currency.code }}:{{ currency.displaySymbol }}"
        class="right-input"
        [formControl]="inputFormControl"
        (keypress)="numberOnly($event)"
        required
        matInput
        (blur)="displayHint = false"
        (focus)="displayHint = true"
      />
    </div>
    @if (inputFormControl.hasError('required')) {
      <mat-error>
        {{ 'labels.inputs.' + inputLabel | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    }
    @if (displayHint) {
      <mat-hint class="right-hint">{{
        inputFormControl.value | currency: currency.code : currency.displaySymbol : '1.2-2'
      }}</mat-hint>
    }
    @if (minVal && inputFormControl.hasError('min')) {
      <mat-error>
        {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.Must be at least' | translate }} {{ minVal }}
      </mat-error>
    }
    @if (maxVal && inputFormControl.hasError('max')) {
      <mat-error>
        {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.Must be less or equal to' | translate }}
        {{ maxVal }}
      </mat-error>
    }
  </mat-form-field>
}
@if (!isRequired) {
  <mat-form-field appearance="fill" class="flex-100">
    <mat-label>{{ 'labels.inputs.' + inputLabel | translate }}</mat-label>
    <span matTextSuffix class="m-l-10">{{ currency.code }}</span>
    <span class="flex-auto"></span>
    <input
      LOSxFormatAmount="{{ currency.code }}:{{ currency.displaySymbol }}"
      class="right-input"
      [formControl]="inputFormControl"
      (keypress)="numberOnly($event)"
      matInput
      (blur)="displayHint = false"
      (focus)="displayHint = true"
    />
    @if (displayHint) {
      <mat-hint class="right-hint">{{
        inputFormControl.value | currency: currency.code : currency.displaySymbol : '1.2-2'
      }}</mat-hint>
    }
    @if (minVal && inputFormControl.hasError('min')) {
      <mat-error>
        {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.Must be at least' | translate }} {{ minVal }}
      </mat-error>
    }
    @if (maxVal && inputFormControl.hasError('max')) {
      <mat-error>
        {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.Must be less or equal to' | translate }}
        {{ maxVal }}
      </mat-error>
    }
  </mat-form-field>
}
